// extracted by mini-css-extract-plugin
export default {"mainSection":"styles_mainSection__hiG3u"};